import { render, staticRenderFns } from "./AddendumAdd.vue?vue&type=template&id=793a2922"
import script from "./AddendumAdd.vue?vue&type=script&lang=js"
export * from "./AddendumAdd.vue?vue&type=script&lang=js"
import style0 from "./AddendumAdd.vue?vue&type=style&index=0&id=793a2922&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports